import { getPage } from 'Utils'
import config from 'Config'

export const getContentsQueryVariablesForArchive = (
  queryString,
  uuids,
  size,
  type,
  isArchive,
  negateuuids,
  storeId
) => {
  const query = {
    arguments: {
      uuids: uuids || [],
      type: type || 'article',
      negateuuids: negateuuids || 'no',
      state: 'PUBLISHED',
      isArchive: isArchive || false,
      storeId: storeId || ''
    },
    pagination: {
      page: getPage(queryString),
      size: size || config.pagination.articleList
    }
  }
  return query
}
